
import { Component, Vue } from 'vue-property-decorator'
import {
  CreateRoadSurface,
  UpdateRoadSurface,
  DeleteRoadSurface,
  ListRoadSurfaces
} from '@/api/baseData'
import { IRoadSurface } from '@/api/types'

@Component({
  name: 'RoadSurfaceTab'
})
export default class extends Vue {
  private list: IRoadSurface[] = []
  private listLoading = false

  private dialogFormVisible = false
  private dialogStatus = ''
  private temp: IRoadSurface = {
    id: -1,
    name: '',
  }

  private rules = {
    name: [{ required: true, message: '请输入路面名称', trigger: 'blur' }],
    code: [{ required: true, message: '请输入路面编码', trigger: 'blur' }],
    price: [{ required: true, message: '请输入路面价格', trigger: 'blur' }]
  }

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    try {
      const { data } = await ListRoadSurfaces()
      this.list = data || []
    } catch (error) {
      console.error('获取路面列表失败', error)
    } finally {
      this.listLoading = false
    }
  }

  private resetTemp() {
    this.temp = {
      id: -1,
      name: '',
    }
  }

  private handleCreate() {
    this.resetTemp()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async createData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        try {
          await CreateRoadSurface(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建路面成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        } catch (error) {
          console.error('创建路面失败', error)
        }
      }
    })
  }

  private handleUpdate(row: any) {
    this.temp = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async updateData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        const tempData = Object.assign({}, this.temp)
        try {
          if (tempData.id !== undefined) {
            const updateData = {
              id: Number(tempData.id),
              name: tempData.name,
            }
            await UpdateRoadSurface(updateData)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新路面成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }
        } catch (error) {
          console.error('更新路面失败', error)
        }
      }
    })
  }

  private async handleDelete(row: any) {
    this.$confirm('确认删除该路面?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      try {
        await DeleteRoadSurface({ id: row.id })
        this.$notify({
          title: '成功',
          message: '删除路面成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (error) {
        console.error('删除路面失败', error)
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
}
